import { actions, createActionTypes, api } from '../../utils/api';

const NAMESPACE = 'LOAD_USER_DATA';
const TYPES = createActionTypes(NAMESPACE);

const action = () => (dispatch) => dispatch(actions.callAPI(NAMESPACE, api.users.profile.get()));

export default { action, TYPES };
